/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Hmotnost rakety (g)`
};

const da_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Ketsjerens vægt (g)`
};

const de_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Gewicht des Schlägers (g)`
};

const en_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Racket weight (g)`
};

const es_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso de la raqueta (g)`
};

const fr_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Poids de la raquette (g)`
};

const hu_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Ütő Súlya (g)`
};

const it_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso della racchetta (g)`
};

const nl_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Racket gewicht (g)`
};

const pl_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Waga rakiety (g)`
};

const pt_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso da raquete (g)`
};

const sv_attributes_racket_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Racketens vikt (g)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_racket_weight = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_racket_weight(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_racket_weight", locale)
	if (locale === "cs") return cs_attributes_racket_weight(inputs)
	if (locale === "da") return da_attributes_racket_weight(inputs)
	if (locale === "de") return de_attributes_racket_weight(inputs)
	if (locale === "en") return en_attributes_racket_weight(inputs)
	if (locale === "es") return es_attributes_racket_weight(inputs)
	if (locale === "fr") return fr_attributes_racket_weight(inputs)
	if (locale === "hu") return hu_attributes_racket_weight(inputs)
	if (locale === "it") return it_attributes_racket_weight(inputs)
	if (locale === "nl") return nl_attributes_racket_weight(inputs)
	if (locale === "pl") return pl_attributes_racket_weight(inputs)
	if (locale === "pt") return pt_attributes_racket_weight(inputs)
	return sv_attributes_racket_weight(inputs)
};
export { attributes_racket_weight as "attributes.racket_weight" }